import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { Constants } from '../../constants/constants';
import { AdminRoleService } from '../../service/admin-role.service';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { EnvService } from '../../service/env.service';
import { ToastService } from '../../service/toast.service';
import { UtilService } from '../../service/util.service';
import { SearchDataService } from '../../service/search-data.service';

@Component({
  selector: 'app-user-list-template',
  templateUrl: './user-list-template.component.html',
  styleUrls: ['./user-list-template.component.scss']
})
export class UserListTemplateComponent implements OnInit {

  @Input() admins: Array<any>;
  selectedAdmins: Array<string> = new Array();
  loggedInUserId: any;
  selectedAdminsCount = 0;
  deletedAdminsCount = 0;
  deleteAdminsFailed: Array<string> = new Array();

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService,
    private adminRoleService: AdminRoleService, private env: EnvService, private searchService: SearchDataService) {

  }

  ngOnInit(): void {
    this.loggedInUserId = this.authService.loggedInUser.userId;
  }

  navigateToDetailPage(user) {
    console.log("Selected user : ", user);
    this.utilService.selectedAccountUser = user;
    this.utilService.isOpenFromSearch = true;
  }

  onAdminSelected(id: string) {
    console.log("admin id::", id);
    let itemIndex = this.selectedAdmins.indexOf(id);
    if (itemIndex !== -1) {
      this.selectedAdmins.splice(itemIndex, 1);
    } else {
      this.selectedAdmins.push(id);
    }
    console.log("selected admins::", this.selectedAdmins);
  }

  cancelDeleteUser() {
    this.resetDeleteUser();
    this.resetCheckbox();
  }

  resetDeleteUser() {
    this.selectedAdmins = [];
    this.selectedAdminsCount = 0;
    this.deletedAdminsCount = 0;
    this.deleteAdminsFailed = [];
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

  onDeleteAdmins() {
    console.log("Received the request for delet admins::", this.selectedAdmins);
    if (this.selectedAdmins.length > 0) {
      this.selectedAdminsCount = this.selectedAdmins.length;
      this.selectedAdmins.forEach(userId => {
        this.deleteUser(userId);
      });
    } else {
      this.toast.showWarning("No user selected");
    }
  }

  deleteUser(userId) {
    this.utilService.showSpinner();
    this.apiService.deleteAccountUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.deletedAdminsCount += 1;
      this.resetAdminsDeleted();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deleteUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        this.deleteAdminsFailed.push(userId);
        this.resetAdminsDeleted();
      }
    });
  }

  resetAdminsDeleted() {
    if (this.selectedAdminsCount == (this.deletedAdminsCount + this.deleteAdminsFailed.length)) {

      if (this.deleteAdminsFailed.length == 0) {
        this.toast.showSuccess("Users Deleted successfully");
      } else {
        this.toast.showError("Delete failed for users : " + this.deleteAdminsFailed.length);
      }
      this.searchService.searchForData(this.searchService.searchKey);
      this.resetDeleteUser();
    }
  }

}
